import { LeaveListSummary } from './LeavelistSummary';

export default LeaveListSummary;
